export default function ActionPanel({ title, description, value, action, footer, className = '' }) {
  return (
    <div className={`rounded-[16px] border border-white/8 bg-white/[0.03] p-3 ${className}`}>
      <p className="text-sm font-medium text-slate-100">{title}</p>
      {description ? <p className="mt-1 text-sm text-slate-400">{description}</p> : null}
      {value ? (
        <div className="mt-3 rounded-[14px] border border-white/8 bg-slate-950/40 p-2.5 text-sm text-slate-200">
          {value}
        </div>
      ) : null}
      {action ? <div className="mt-3">{action}</div> : null}
      {footer ? <div className="mt-2 text-xs text-slate-500">{footer}</div> : null}
    </div>
  );
}
